<div id="outerContainer">
  <div class="pdf-container" [attr.data-automation-id]="'disclosure-pdf-wrapper'">
    <pdf-viewer [src]="pdfSrc" [(page)]="page" [rotation]="rotation" [original-size]="originalSize"
      [fit-to-page]="fitToPage" (after-load-complete)="afterLoadComplete($event)" [zoom]="zoom"
      [zoom-scale]="'page-width'" [show-all]="showAll" [stick-to-page]="stickToPage" [render-text]="renderText"
      [external-link-target]="'blank'" [autoresize]="autoresize" (error)="onError($event)"
      (on-progress)="onProgress($event)" (page-rendered)="pageRendered($event)"></pdf-viewer>
  </div>
</div>
